import { useEffect, useMemo } from "react";
import HomeGoogleAds from "../../components/advertisement/home-google-ads";
import LoadHomeGoogleAds from "../../components/advertisement/load-home-google-ads";
import LoginDescriptionComponent from "./component/404-login-components/description.component";
import NotFoundLogin from "./component/404-login.component";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import LoginExtraFieldOneComponent from "./component/404-login-components/extra-field-1.component";
import LoginExtraFieldTwoComponent from "./component/404-login-components/extra-field-2.component";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

const LoginPage = () => {
  const cachedGoogleAds = useMemo(() => <HomeGoogleAds />, []);
  const cachedUseDfpSlot = useMemo(() => <LoadHomeGoogleAds />, []);

  const { RapsEuropeData } = useSelector((state: RootState) => state.rapsEurope);

  const path = "%2FLogin";
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, []);

  return (<>
    <Helmet>
      <title>{RapsEuropeData[0]?.result[0].menuItemName}</title>
    </Helmet>
    <div className="brand-texture site-login">
      <div className="container">
        <div className="row">
          <LoginDescriptionComponent />
          <div className="col-md-12">
            {/*<div className="mobile-jump-links">
              <ul className="list-unstyled">
                <li>
                  <a href="#join-raps">
                    Join RAPS <i className="fa-regular fa-circle-chevron-down"></i>
                  </a>
                </li>
                <li>
                  <a href="#create-account">
                    Create an Account <i className="fa-regular fa-circle-chevron-down"></i>
                  </a>
                </li>
              </ul>
            </div>*/}
            <div className="flex-group flex-login">
              <div className="flex-block login-block">
                <div>
                  <NotFoundLogin isLoginPage={true} />
                </div>
              </div>
              <LoginExtraFieldOneComponent />
              <LoginExtraFieldTwoComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
    <p>&nbsp;</p>
    {cachedGoogleAds}
    {cachedUseDfpSlot}
    <p>&nbsp;</p>
  </>);
};

export default LoginPage;
